// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timePicker_timePicker__54y-- {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  transition: all 0.5s;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  padding: 4px 10px 4px 10px;
  border-radius: 16px;
  color: var(--HightEmphasis);
  border: none;
  background: var(--Gray88); }

.timePicker_label__yScgj {
  margin: 0; }

.timePicker_input__9gSxS {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background: var(--Gray88); }
`, "",{"version":3,"sources":["webpack://./src/components/timePicker/timePicker.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAW;EAEX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB,EAAA;;AAG7B;EACI,SAAS,EAAA;;AAGb;EACI,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,yBAAyB,EAAA","sourcesContent":[".timePicker{\n    width: 100%;\n    height: -moz-fit-content;\n    height: fit-content;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    transition: all 0.5s;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    padding: 4px 10px 4px 10px;\n    border-radius: 16px;\n    color: var(--HightEmphasis);\n    border: none;\n    background: var(--Gray88);\n}\n\n.label{\n    margin: 0;\n}\n\n.input{\n    appearance: none;\n    -webkit-appearance: none;\n    border: none;\n    background: var(--Gray88);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timePicker": `timePicker_timePicker__54y--`,
	"label": `timePicker_label__yScgj`,
	"input": `timePicker_input__9gSxS`
};
export default ___CSS_LOADER_EXPORT___;
